import {
  useCurrentUser,
  useCurriculum,
} from "@twinkltech/curriculum-architect-domain-hooks";

import { EditCurriculumModal } from "./EditCurriculumModal";

export const EditCurriculumModalContainer = ({
  curriculumId,
  open,
  setOpen,
  ...props
}: {
  curriculumId: string;
  open: boolean;
  setOpen: (open: boolean) => void;
}) => {
  const {
    actions: { update },
    data: curriculum,
    error,
    isLoading,
  } = useCurriculum({ id: curriculumId });

  const { data: user } = useCurrentUser();

  const isSchoolAccount =
    user?.persona.accountType === "school" ||
    user?.persona.accountType === "multi-school";

  return (
    <EditCurriculumModal
      curriculum={curriculum}
      error={error}
      isLoading={isLoading}
      isSchoolAccount={isSchoolAccount}
      open={open}
      setOpen={setOpen}
      onHandleSubmit={update.apply}
      {...props}
    />
  );
};
